import React, { useState } from 'react'
import { Player as ReactPlayer, ControlBar } from 'video-react'

export default function Player({
  url,
  autoplay = false,
  isPlaying = false,
  ...props
}) {
  const [player, setPlayer] = useState()

  React.useEffect(() => {
    if (isPlaying && player) {
      player.play()
    }
  }, [isPlaying, player]) // eslint-disable-line

  return (
    <ReactPlayer
      fluid={false}
      width="100%"
      height="100%"
      src={url}
      autoPlay={autoplay}
      muted={autoplay && true}
      ref={pl => setPlayer(pl)}
      {...props}>
      <ControlBar disableCompletely={true} />
    </ReactPlayer>
  )
}
